/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InstancesSummary } from '../models';
// @ts-ignore
import type { ListInstancesResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * InstanceAPIApi - axios parameter creator
 * @export
 */
export const InstanceAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns aggregated instance metrics across the filtered fleet.
         * @summary Returns aggregated instance metrics across the filtered fleet.
         * @param {string} organizationId Organization ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {Array<string>} [regions] Filter by regions (e.g., \&quot;us-east-1\&quot;).
         * @param {Array<string>} [availabilityZones] Filter by availability zones (e.g., \&quot;us-east-1a\&quot;).
         * @param {Array<string>} [instanceTypes] Filter by instance types (e.g., \&quot;m5.xlarge\&quot;).
         * @param {Array<string>} [instanceIds] Filter by instance IDs.
         * @param {boolean} [spot] Filter by spot or on-demand lifecycle.
         * @param {Array<InstanceAPIGetInstancesSummaryMetricsEnum>} [metrics] Metrics to include in the response. If empty, all metrics are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instanceAPIGetInstancesSummary: async (organizationId: string, startTime?: string, endTime?: string, timeZone?: string, regions?: Array<string>, availabilityZones?: Array<string>, instanceTypes?: Array<string>, instanceIds?: Array<string>, spot?: boolean, metrics?: Array<InstanceAPIGetInstancesSummaryMetricsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('instanceAPIGetInstancesSummary', 'organizationId', organizationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/instances-summary`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (regions) {
                localVarQueryParameter['regions'] = regions;
            }

            if (availabilityZones) {
                localVarQueryParameter['availabilityZones'] = availabilityZones;
            }

            if (instanceTypes) {
                localVarQueryParameter['instanceTypes'] = instanceTypes;
            }

            if (instanceIds) {
                localVarQueryParameter['instanceIds'] = instanceIds;
            }

            if (spot !== undefined) {
                localVarQueryParameter['spot'] = spot;
            }

            if (metrics) {
                localVarQueryParameter['metrics'] = metrics;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists cloud instances with aggregated metrics over a time range.
         * @summary Lists cloud instances with aggregated metrics.
         * @param {string} organizationId Organization ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [regions] Filter by regions (e.g., \&quot;us-east-1\&quot;).
         * @param {Array<string>} [availabilityZones] Filter by availability zones (e.g., \&quot;us-east-1a\&quot;).
         * @param {Array<string>} [instanceTypes] Filter by instance types (e.g., \&quot;m5.xlarge\&quot;).
         * @param {Array<string>} [instanceIds] Filter by instance IDs.
         * @param {boolean} [spot] Filter by spot or on-demand lifecycle.
         * @param {Array<InstanceAPIListInstancesMetricsEnum>} [metrics] Metrics to include in the response. If empty, all metrics are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instanceAPIListInstances: async (organizationId: string, startTime?: string, endTime?: string, timeZone?: string, pageLimit?: string, pageCursor?: string, regions?: Array<string>, availabilityZones?: Array<string>, instanceTypes?: Array<string>, instanceIds?: Array<string>, spot?: boolean, metrics?: Array<InstanceAPIListInstancesMetricsEnum>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('instanceAPIListInstances', 'organizationId', organizationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/instances`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }

            if (timeZone !== undefined) {
                localVarQueryParameter['timeZone'] = timeZone;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (regions) {
                localVarQueryParameter['regions'] = regions;
            }

            if (availabilityZones) {
                localVarQueryParameter['availabilityZones'] = availabilityZones;
            }

            if (instanceTypes) {
                localVarQueryParameter['instanceTypes'] = instanceTypes;
            }

            if (instanceIds) {
                localVarQueryParameter['instanceIds'] = instanceIds;
            }

            if (spot !== undefined) {
                localVarQueryParameter['spot'] = spot;
            }

            if (metrics) {
                localVarQueryParameter['metrics'] = metrics;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstanceAPIApi - functional programming interface
 * @export
 */
export const InstanceAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstanceAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns aggregated instance metrics across the filtered fleet.
         * @summary Returns aggregated instance metrics across the filtered fleet.
         * @param {string} organizationId Organization ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {Array<string>} [regions] Filter by regions (e.g., \&quot;us-east-1\&quot;).
         * @param {Array<string>} [availabilityZones] Filter by availability zones (e.g., \&quot;us-east-1a\&quot;).
         * @param {Array<string>} [instanceTypes] Filter by instance types (e.g., \&quot;m5.xlarge\&quot;).
         * @param {Array<string>} [instanceIds] Filter by instance IDs.
         * @param {boolean} [spot] Filter by spot or on-demand lifecycle.
         * @param {Array<InstanceAPIGetInstancesSummaryMetricsEnum>} [metrics] Metrics to include in the response. If empty, all metrics are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instanceAPIGetInstancesSummary(organizationId: string, startTime?: string, endTime?: string, timeZone?: string, regions?: Array<string>, availabilityZones?: Array<string>, instanceTypes?: Array<string>, instanceIds?: Array<string>, spot?: boolean, metrics?: Array<InstanceAPIGetInstancesSummaryMetricsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstancesSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instanceAPIGetInstancesSummary(organizationId, startTime, endTime, timeZone, regions, availabilityZones, instanceTypes, instanceIds, spot, metrics, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstanceAPIApi.instanceAPIGetInstancesSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists cloud instances with aggregated metrics over a time range.
         * @summary Lists cloud instances with aggregated metrics.
         * @param {string} organizationId Organization ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {string} [timeZone] Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {Array<string>} [regions] Filter by regions (e.g., \&quot;us-east-1\&quot;).
         * @param {Array<string>} [availabilityZones] Filter by availability zones (e.g., \&quot;us-east-1a\&quot;).
         * @param {Array<string>} [instanceTypes] Filter by instance types (e.g., \&quot;m5.xlarge\&quot;).
         * @param {Array<string>} [instanceIds] Filter by instance IDs.
         * @param {boolean} [spot] Filter by spot or on-demand lifecycle.
         * @param {Array<InstanceAPIListInstancesMetricsEnum>} [metrics] Metrics to include in the response. If empty, all metrics are returned.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instanceAPIListInstances(organizationId: string, startTime?: string, endTime?: string, timeZone?: string, pageLimit?: string, pageCursor?: string, regions?: Array<string>, availabilityZones?: Array<string>, instanceTypes?: Array<string>, instanceIds?: Array<string>, spot?: boolean, metrics?: Array<InstanceAPIListInstancesMetricsEnum>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListInstancesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instanceAPIListInstances(organizationId, startTime, endTime, timeZone, pageLimit, pageCursor, regions, availabilityZones, instanceTypes, instanceIds, spot, metrics, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InstanceAPIApi.instanceAPIListInstances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InstanceAPIApi - factory interface
 * @export
 */
export const InstanceAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstanceAPIApiFp(configuration)
    return {
        /**
         * Returns aggregated instance metrics across the filtered fleet.
         * @summary Returns aggregated instance metrics across the filtered fleet.
         * @param {InstanceAPIApiInstanceAPIGetInstancesSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instanceAPIGetInstancesSummary(requestParameters: InstanceAPIApiInstanceAPIGetInstancesSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<InstancesSummary> {
            return localVarFp.instanceAPIGetInstancesSummary(requestParameters.organizationId, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.regions, requestParameters.availabilityZones, requestParameters.instanceTypes, requestParameters.instanceIds, requestParameters.spot, requestParameters.metrics, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists cloud instances with aggregated metrics over a time range.
         * @summary Lists cloud instances with aggregated metrics.
         * @param {InstanceAPIApiInstanceAPIListInstancesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instanceAPIListInstances(requestParameters: InstanceAPIApiInstanceAPIListInstancesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListInstancesResponse> {
            return localVarFp.instanceAPIListInstances(requestParameters.organizationId, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.regions, requestParameters.availabilityZones, requestParameters.instanceTypes, requestParameters.instanceIds, requestParameters.spot, requestParameters.metrics, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for instanceAPIGetInstancesSummary operation in InstanceAPIApi.
 * @export
 * @interface InstanceAPIApiInstanceAPIGetInstancesSummaryRequest
 */
export interface InstanceAPIApiInstanceAPIGetInstancesSummaryRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly organizationId: string

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly endTime?: string

    /**
     * Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly timeZone?: string

    /**
     * Filter by regions (e.g., \&quot;us-east-1\&quot;).
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly regions?: Array<string>

    /**
     * Filter by availability zones (e.g., \&quot;us-east-1a\&quot;).
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly availabilityZones?: Array<string>

    /**
     * Filter by instance types (e.g., \&quot;m5.xlarge\&quot;).
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly instanceTypes?: Array<string>

    /**
     * Filter by instance IDs.
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly instanceIds?: Array<string>

    /**
     * Filter by spot or on-demand lifecycle.
     * @type {boolean}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly spot?: boolean

    /**
     * Metrics to include in the response. If empty, all metrics are returned.
     * @type {Array<'INSTANCE_SUMMARY_METRIC_UNSPECIFIED' | 'SUMMARY_COST_TOTAL' | 'SUMMARY_LISTING_COST_TOTAL' | 'SUMMARY_CPU_UTILIZATION_AVG' | 'SUMMARY_MEMORY_UTILIZATION_AVG' | 'SUMMARY_IDLE_INSTANCES_COUNT' | 'SUMMARY_UNDERUTILIZED_INSTANCES_COUNT'>}
     * @memberof InstanceAPIApiInstanceAPIGetInstancesSummary
     */
    readonly metrics?: Array<InstanceAPIGetInstancesSummaryMetricsEnum>
}

/**
 * Request parameters for instanceAPIListInstances operation in InstanceAPIApi.
 * @export
 * @interface InstanceAPIApiInstanceAPIListInstancesRequest
 */
export interface InstanceAPIApiInstanceAPIListInstancesRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly organizationId: string

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly endTime?: string

    /**
     * Optional time zone in IANA format, e.g., \&#39;Europe/Madrid\&#39;.  Default is Etc/UTC.
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly timeZone?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly pageCursor?: string

    /**
     * Filter by regions (e.g., \&quot;us-east-1\&quot;).
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly regions?: Array<string>

    /**
     * Filter by availability zones (e.g., \&quot;us-east-1a\&quot;).
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly availabilityZones?: Array<string>

    /**
     * Filter by instance types (e.g., \&quot;m5.xlarge\&quot;).
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly instanceTypes?: Array<string>

    /**
     * Filter by instance IDs.
     * @type {Array<string>}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly instanceIds?: Array<string>

    /**
     * Filter by spot or on-demand lifecycle.
     * @type {boolean}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly spot?: boolean

    /**
     * Metrics to include in the response. If empty, all metrics are returned.
     * @type {Array<'INSTANCE_METRIC_UNSPECIFIED' | 'CPU_UTILIZATION_AVG' | 'CPU_UTILIZATION_P95' | 'CPU_UTILIZATION_MAX' | 'MEMORY_UTILIZATION_AVG' | 'MEMORY_UTILIZATION_P95' | 'MEMORY_UTILIZATION_MAX' | 'NETWORK_IN_BYTES' | 'NETWORK_OUT_BYTES' | 'DISK_READ_OPS' | 'DISK_WRITE_OPS' | 'EBS_READ_OPS' | 'EBS_WRITE_OPS' | 'LISTING_COST_HOURLY' | 'COST_HOURLY' | 'LISTING_COST_TOTAL' | 'COST_TOTAL'>}
     * @memberof InstanceAPIApiInstanceAPIListInstances
     */
    readonly metrics?: Array<InstanceAPIListInstancesMetricsEnum>
}

/**
 * InstanceAPIApi - object-oriented interface
 * @export
 * @class InstanceAPIApi
 * @extends {BaseAPI}
 */
export class InstanceAPIApi extends BaseAPI {
    /**
     * Returns aggregated instance metrics across the filtered fleet.
     * @summary Returns aggregated instance metrics across the filtered fleet.
     * @param {InstanceAPIApiInstanceAPIGetInstancesSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstanceAPIApi
     */
    public instanceAPIGetInstancesSummary(requestParameters: InstanceAPIApiInstanceAPIGetInstancesSummaryRequest, options?: RawAxiosRequestConfig) {
        return InstanceAPIApiFp(this.configuration).instanceAPIGetInstancesSummary(requestParameters.organizationId, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.regions, requestParameters.availabilityZones, requestParameters.instanceTypes, requestParameters.instanceIds, requestParameters.spot, requestParameters.metrics, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists cloud instances with aggregated metrics over a time range.
     * @summary Lists cloud instances with aggregated metrics.
     * @param {InstanceAPIApiInstanceAPIListInstancesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstanceAPIApi
     */
    public instanceAPIListInstances(requestParameters: InstanceAPIApiInstanceAPIListInstancesRequest, options?: RawAxiosRequestConfig) {
        return InstanceAPIApiFp(this.configuration).instanceAPIListInstances(requestParameters.organizationId, requestParameters.startTime, requestParameters.endTime, requestParameters.timeZone, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.regions, requestParameters.availabilityZones, requestParameters.instanceTypes, requestParameters.instanceIds, requestParameters.spot, requestParameters.metrics, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const InstanceAPIGetInstancesSummaryMetricsEnum = {
    INSTANCE_SUMMARY_METRIC_UNSPECIFIED: 'INSTANCE_SUMMARY_METRIC_UNSPECIFIED',
    SUMMARY_COST_TOTAL: 'SUMMARY_COST_TOTAL',
    SUMMARY_LISTING_COST_TOTAL: 'SUMMARY_LISTING_COST_TOTAL',
    SUMMARY_CPU_UTILIZATION_AVG: 'SUMMARY_CPU_UTILIZATION_AVG',
    SUMMARY_MEMORY_UTILIZATION_AVG: 'SUMMARY_MEMORY_UTILIZATION_AVG',
    SUMMARY_IDLE_INSTANCES_COUNT: 'SUMMARY_IDLE_INSTANCES_COUNT',
    SUMMARY_UNDERUTILIZED_INSTANCES_COUNT: 'SUMMARY_UNDERUTILIZED_INSTANCES_COUNT'
} as const;
export type InstanceAPIGetInstancesSummaryMetricsEnum = typeof InstanceAPIGetInstancesSummaryMetricsEnum[keyof typeof InstanceAPIGetInstancesSummaryMetricsEnum];
/**
 * @export
 */
export const InstanceAPIListInstancesMetricsEnum = {
    INSTANCE_METRIC_UNSPECIFIED: 'INSTANCE_METRIC_UNSPECIFIED',
    CPU_UTILIZATION_AVG: 'CPU_UTILIZATION_AVG',
    CPU_UTILIZATION_P95: 'CPU_UTILIZATION_P95',
    CPU_UTILIZATION_MAX: 'CPU_UTILIZATION_MAX',
    MEMORY_UTILIZATION_AVG: 'MEMORY_UTILIZATION_AVG',
    MEMORY_UTILIZATION_P95: 'MEMORY_UTILIZATION_P95',
    MEMORY_UTILIZATION_MAX: 'MEMORY_UTILIZATION_MAX',
    NETWORK_IN_BYTES: 'NETWORK_IN_BYTES',
    NETWORK_OUT_BYTES: 'NETWORK_OUT_BYTES',
    DISK_READ_OPS: 'DISK_READ_OPS',
    DISK_WRITE_OPS: 'DISK_WRITE_OPS',
    EBS_READ_OPS: 'EBS_READ_OPS',
    EBS_WRITE_OPS: 'EBS_WRITE_OPS',
    LISTING_COST_HOURLY: 'LISTING_COST_HOURLY',
    COST_HOURLY: 'COST_HOURLY',
    LISTING_COST_TOTAL: 'LISTING_COST_TOTAL',
    COST_TOTAL: 'COST_TOTAL'
} as const;
export type InstanceAPIListInstancesMetricsEnum = typeof InstanceAPIListInstancesMetricsEnum[keyof typeof InstanceAPIListInstancesMetricsEnum];
